// extracted by mini-css-extract-plugin
export default {"mealPlanContainer":"style_mealPlanContainer__PHuz3","mealPlan":"style_mealPlan__FBtfE","card":"style_card__MqU2q","cardImage":"style_cardImage__8fDOG"};